import { COLORS } from '@btime/constants'
import React from 'react'

import { Text } from '../../components/presentation/Text'
import { useOpenChecklistModal } from '../../utils/routes/modals/modalsActions'
import FlexGrid from '../../components/structure/FlexGrid'
import Icon from '../../components/shapes/Icon'
import Link from '../../components/actions/Link'

const ChecklistPresenter = ({ checklist, fontSize, hideIcon, ...props }) => {
  const openDetailsModal = useOpenChecklistModal()
  if (!checklist || !checklist.id) return false

  return (
    <Link block onClick={() => openDetailsModal(checklist)} underlineOnHover>
      <FlexGrid justify="flex-start" gutter={0.15}>
        <Text size={fontSize} {...props}>
          {checklist.name}
        </Text>
        {!hideIcon && <Icon name="BsSearch" color={COLORS.dark3} size="0.8rem" />}
      </FlexGrid>
    </Link>
  )
}

export default ChecklistPresenter
